'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-right: 0;\n    ', ';\n'], ['\n    padding-right: 0;\n    ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n        padding-right: 15px;\n    '], ['\n        padding-right: 15px;\n    ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _wendysI18next = require('wendys-i18next');

var _CountryAndCurrency = require('./CountryAndCurrency');

var _CountryAndCurrency2 = _interopRequireDefault(_CountryAndCurrency);

var _dist = require('wendys-common-web-ui/dist');

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var PropTypes = require('prop-types');
/**
 * Created by jlitt04 on 07/19/2017.
 */

var React = require('react');
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var FloatLabelField = require('../FloatLabelField.js');

module.exports = createReactClass({
    displayName: 'exports',

    propTypes: {
        subTitle: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        submitButtonText: PropTypes.string.isRequired,
        postalCode: PropTypes.string,
        requireTerms: PropTypes.bool.isRequired
    },
    getInitialState: function getInitialState() {
        return {
            checkedTerms: false,
            formValid: false,
            postalError: ''
        };
    },

    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
        if (this.props.shouldShowLocalizationFlow) {
            if (prevState.postalError !== this.state.postalError) this.checkFormValidity();
            return;
        }
        if (!ReactDOM.findDOMNode(this.refs.postal_code).children[0].value && prevProps.postalCode !== this.props.postalCode) {
            ReactDOM.findDOMNode(this.refs.postal_code).children[0].value = this.props.postalCode;
            if (this.refs.postal_code && this.refs.postal_code.isPopulated) {
                this.refs.postal_code.isPopulated({
                    currentTarget: { value: this.props.postalCode }
                });
            }
        }
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();

        var params = {
            terms: this.state.checkedTerms
        };

        if (this.props.handleSubmit) {
            if (this.props.shouldShowLocalizationFlow) {
                params = _extends({}, params, {
                    cntry: this.props.selectedLocale.postValue,
                    currency: this.props.currencyPostValue,
                    postal: this.state.postalCode
                });
            } else {
                params.postal = ReactDOM.findDOMNode(this.refs.postal_code).children[0].value;
                params.cntry = this.mapPostalTypeToCntry(this.checkAddressCodeType(params.postal)); //added cntry to return based on zipcode type
            }
            this.props.handleSubmit(params);
        }
    },
    handleCheckBox: function handleCheckBox(cb) {
        this.setState({
            checkedTerms: cb.currentTarget.checked
        }, this.checkFormValidity);
    },
    checkFormValidity: function checkFormValidity() {
        var disabled = '';
        if (this.props.shouldShowLocalizationFlow) {
            disabled += this.state.postalError;
        } else {
            disabled += this.validatePostalCode(ReactDOM.findDOMNode(this.refs.postal_code).children[0].value, true);
        }
        disabled += this.state.checkedTerms || !this.props.requireTerms ? '' : 'false';

        this.setState({ formValid: !disabled });
    },
    getPostalCodeValue: function getPostalCodeValue(value, postalError) {
        this.setState({
            postalCode: value,
            postalError: postalError
        });
    },
    getPostalCode: function getPostalCode() {
        return ReactDOM.findDOMNode(this.refs.postal_code).children[0].value;
    },
    isUSSelected: function isUSSelected() {
        return this.props.selectedLocale.id === 1;
    },
    render: function render() {
        var Config = require('../../lib/config').urls;

        var disableButton = !this.state.formValid;
        var disableSubmit = this.state.formValid ? 'btn btn-primary' : 'btn btn-primary disable-submit';

        return React.createElement(
            'div',
            { className: 'sign-up-form' },
            React.createElement(
                'div',
                { className: 'welcome-message' },
                this.props.subTitle
            ),
            React.createElement(
                'form',
                { className: 'row', onSubmit: this.onSubmit },
                this.props.shouldShowLocalizationFlow ? React.createElement(
                    'div',
                    null,
                    React.createElement(_CountryAndCurrency2.default, {
                        country: this.props.selectedLocale.value,
                        flagUrl: this.props.flagUrl,
                        currencyOptions: this.props.currencyOptions,
                        selectedCurrency: this.props.selectedCurrency,
                        changeSelectedCurrency: this.props.changeSelectedCurrency,
                        fullWidth: true
                    }),
                    React.createElement(
                        PostalWrapper,
                        null,
                        React.createElement(_dist.PostalCode, {
                            USLabel: (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_code'),
                            USError: (0, _wendysI18next.getTranslatedString)('email_sign_up_invalid_postal'),
                            CALabel: (0, _wendysI18next.getTranslatedString)('email_sign_up_postal_code'),
                            CAError: (0, _wendysI18next.getTranslatedString)('email_sign_up_invalid_postal'),
                            isUSSelected: this.isUSSelected(),
                            geocode: this.props.postalCode,
                            description: (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_desc'),
                            getValue: this.getPostalCodeValue
                        })
                    )
                ) : React.createElement(
                    'div',
                    null,
                    React.createElement(FloatLabelField, {
                        required: true,
                        id: 'postal-input',
                        validationFunction: this.validatePostalCode,
                        type: this.isUSSelected() ? 'number' : 'text',
                        placeHolder: this.isUSSelected() ? (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_code') : (0, _wendysI18next.getTranslatedString)('email_sign_up_postal_code'),
                        onChangeHandler: this.validatePostalCode,
                        ref: 'postal_code',
                        inputAttributes: { 'aria-describedby': 'field-description-zip' }
                    }),
                    React.createElement(
                        'div',
                        { id: 'field-description-zip', className: 'col-xs-12 field-description' },
                        React.createElement(
                            'div',
                            null,
                            (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_desc')
                        )
                    )
                ),
                this.props.requireTerms && React.createElement(
                    'div',
                    { className: 'col-xs-12 checkbox-container' },
                    React.createElement(
                        'div',
                        null,
                        React.createElement(
                            'label',
                            null,
                            React.createElement('input', {
                                required: true,
                                type: 'checkbox',
                                id: 'terms',
                                ref: 'terms',
                                onClick: this.handleCheckBox
                            }),
                            (0, _wendysI18next.getTranslatedString)('rewards_terms_and_conditions_preface'),
                            React.createElement(
                                'a',
                                {
                                    href: Config.terms[(0, _wendysI18next.getLanguage)() + '_' + (0, _wendysI18next.getCountry)()],
                                    target: '_blank'
                                },
                                ' ',
                                (0, _wendysI18next.getTranslatedString)('common_login_terms_of')
                            ),
                            ' ',
                            (0, _wendysI18next.getTranslatedString)('common_login_and'),
                            React.createElement(
                                'a',
                                {
                                    href: Config.privacy[(0, _wendysI18next.getLanguage)() + '_' + (0, _wendysI18next.getCountry)()],
                                    target: '_blank'
                                },
                                ' ',
                                (0, _wendysI18next.getTranslatedString)('common_login_privacy_policy')
                            ),
                            '.'
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'col-xs-12 sign-up-button' },
                    React.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: disableSubmit,
                            disabled: disableButton,
                            id: 'login-btn'
                        },
                        this.props.submitButtonText
                    ),
                    this.props.handleSkipButtonClick && React.createElement(
                        'div',
                        { className: 'skip-btn' },
                        React.createElement(
                            'a',
                            { href: '#', onClick: this.props.handleSkipButtonClick },
                            (0, _wendysI18next.getTranslatedString)('maybe_later').toUpperCase()
                        )
                    )
                )
            )
        );
    },
    validatePostalCode: function validatePostalCode(input, validationCheck) {
        var retValue = '';

        if (!input || input.replace(/\s/g, '') == '') {
            retValue = (0, _wendysI18next.getTranslatedString)('common_login_required');
        } else if (!this.checkAddressCodeType(input)) {
            retValue = (0, _wendysI18next.getTranslatedString)('email_sign_up_invalid_postal');
        } else if (!validationCheck) {
            this.checkFormValidity();
        }
        return retValue;
    },
    checkAddressCodeType: function checkAddressCodeType(code) {
        var zipRegex = /^(\d{5})?$/;
        var postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;

        var type = '';
        if (code.length == 7 && code.match(postalCodeRegex)) {
            type = 'postal';
        } else if (code.length == 5 && code.match(zipRegex)) {
            type = 'zip';
        }

        return type;
    },
    mapPostalTypeToCntry: function mapPostalTypeToCntry(postalType) {
        if (postalType == 'zip') {
            return 'US';
        } else if (postalType == 'postal') {
            return 'CA';
        } else {
            return '';
        }
    }
});

var PostalWrapper = _styledComponents2.default.div(_templateObject, _styledComponentsHelper.media.md(_templateObject2));


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/updatePostalCode.js
// module id = 313
// module chunks = 0